import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrizeForPrecisionRoutingModule } from './prize-for-precision-routing.module';
import { BootstrapPriceForPrecisionComponent } from './components/bootstrap-price-for-precision/bootstrap-price-for-precision.component';
import { PriceForPrecisionDetailsComponent } from './components/price-for-precision-details/price-for-precision-details.component';
import { PriceForPrecisionListComponent } from './components/price-for-precision-list/price-for-precision-list.component';
import { PriceForPrecisionFiltersComponent } from './components/price-for-precision-filters/price-for-precision-filters.component';
import { PriceForPrecisionItemComponent } from './components/price-for-precision-item/price-for-precision-item.component';
import { ComponentsModule, ServicesModule, CoreModule, WaHelperService, CacheInterceptorService } from 'world-archery-lib';
import { PrizeForPrecisionService } from './services/prize-for-precision.service';
import { PriceForPrecisionPanelComponent } from './components/price-for-precision-panel/price-for-precision-panel.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';

@NgModule({
  imports: [
    CommonModule,
    PrizeForPrecisionRoutingModule,
    ComponentsModule,
    ServicesModule,
    HttpClientModule,
    CoreModule,
    CommonPageComponentsModule
  ],
  declarations: [
    BootstrapPriceForPrecisionComponent,
    PriceForPrecisionDetailsComponent,
    PriceForPrecisionListComponent,
    PriceForPrecisionFiltersComponent,
    PriceForPrecisionItemComponent,
    PriceForPrecisionPanelComponent
  ],
  providers: [
    PrizeForPrecisionService,
    WaHelperService,
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptorService, multi: true }
  ]
})
export class PrizeForPrecisionModule { }
